import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b859fb6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "add_task" }
const _hoisted_2 = { class: "flexAlign" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d" }, "*"),
  /*#__PURE__*/_createTextVNode("反馈时间")
], -1))
const _hoisted_4 = { class: "right flexAlign" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"10px"} }, null, -1))
const _hoisted_6 = { class: "flexAlign" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d" }, "*"),
  /*#__PURE__*/_createTextVNode("反馈人")
], -1))
const _hoisted_8 = { class: "right" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"10px"} }, null, -1))
const _hoisted_10 = { class: "flexAlign" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d" }, "*"),
  /*#__PURE__*/_createTextVNode("订单号")
], -1))
const _hoisted_12 = { class: "right" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"10px"} }, null, -1))
const _hoisted_14 = { class: "flexAlign" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d" }, " "),
  /*#__PURE__*/_createTextVNode("问题类型")
], -1))
const _hoisted_16 = { class: "right" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"10px"} }, null, -1))
const _hoisted_18 = { class: "flexAlign" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d" }),
  /*#__PURE__*/_createTextVNode("平方数")
], -1))
const _hoisted_20 = { class: "right" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"10px"} }, null, -1))
const _hoisted_22 = { class: "flexAlign" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d" }, " "),
  /*#__PURE__*/_createTextVNode("涂装类型")
], -1))
const _hoisted_24 = { class: "right" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"10px"} }, null, -1))
const _hoisted_26 = { class: "flexAlign" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d" }, " "),
  /*#__PURE__*/_createTextVNode("问题分类")
], -1))
const _hoisted_28 = { class: "right" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"10px"} }, null, -1))
const _hoisted_30 = { class: "flexAlign" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d" }),
  /*#__PURE__*/_createTextVNode("原因事项")
], -1))
const _hoisted_32 = { class: "right" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"10px"} }, null, -1))
const _hoisted_34 = { class: "flexAlign" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d" }),
  /*#__PURE__*/_createTextVNode("本次解决方案")
], -1))
const _hoisted_36 = { class: "right" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"10px"} }, null, -1))
const _hoisted_38 = { class: "flexAlign" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d" }),
  /*#__PURE__*/_createTextVNode("源头分析杜绝方案")
], -1))
const _hoisted_40 = { class: "right" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"10px"} }, null, -1))
const _hoisted_42 = { class: "flexAlign" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d" }),
  /*#__PURE__*/_createTextVNode("改善进度")
], -1))
const _hoisted_44 = { class: "right" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"10px"} }, null, -1))
const _hoisted_46 = { class: "flexAlign" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d" }),
  /*#__PURE__*/_createTextVNode("源头岗位")
], -1))
const _hoisted_48 = { class: "right" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"10px"} }, null, -1))
const _hoisted_50 = { class: "flexAlign" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d" }),
  /*#__PURE__*/_createTextVNode("责任部门/人")
], -1))
const _hoisted_52 = { class: "right" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"10px"} }, null, -1))
const _hoisted_54 = { class: "flexAlign" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d" }),
  /*#__PURE__*/_createTextVNode("内外部")
], -1))
const _hoisted_56 = { class: "right" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"10px"} }, null, -1))
const _hoisted_58 = { class: "flexAlign" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d" }),
  /*#__PURE__*/_createTextVNode("损失金额合计")
], -1))
const _hoisted_60 = { class: "right" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"10px"} }, null, -1))
const _hoisted_62 = { class: "flexAlign" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d" }),
  /*#__PURE__*/_createTextVNode("差旅费用")
], -1))
const _hoisted_64 = { class: "right" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"10px"} }, null, -1))
const _hoisted_66 = { class: "flexAlign" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d" }),
  /*#__PURE__*/_createTextVNode("人工工资")
], -1))
const _hoisted_68 = { class: "right" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"10px"} }, null, -1))
const _hoisted_70 = { class: "flexAlign" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d" }),
  /*#__PURE__*/_createTextVNode("材料费")
], -1))
const _hoisted_72 = { class: "right" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"10px"} }, null, -1))
const _hoisted_74 = { class: "flexAlign" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d" }),
  /*#__PURE__*/_createTextVNode("快递费")
], -1))
const _hoisted_76 = { class: "right" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"10px"} }, null, -1))
const _hoisted_78 = { class: "flexAlign" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d" }),
  /*#__PURE__*/_createTextVNode("罚款")
], -1))
const _hoisted_80 = { class: "right" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"10px"} }, null, -1))
const _hoisted_82 = { class: "fine-section" }
const _hoisted_83 = { class: "fine-header" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"bold","margin-right":"10px"} }, "罚款人明细", -1))
const _hoisted_85 = /*#__PURE__*/_createTextVNode("+ 添加罚款人")
const _hoisted_86 = {
  key: 0,
  class: "fine-list"
}
const _hoisted_87 = { class: "fine-row" }
const _hoisted_88 = { class: "fine-field" }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "罚款人姓名：", -1))
const _hoisted_90 = { class: "fine-field" }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "罚款金额：", -1))
const _hoisted_92 = { class: "fine-field" }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "罚款时间：", -1))
const _hoisted_94 = { class: "fine-actions" }
const _hoisted_95 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_96 = {
  key: 1,
  style: {"color":"#999","font-size":"12px","margin-top":"5px"}
}
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"10px"} }, null, -1))
const _hoisted_98 = { class: "flexAlign" }
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d" }),
  /*#__PURE__*/_createTextVNode("备注")
], -1))
const _hoisted_100 = { class: "right" }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"10px"} }, null, -1))
const _hoisted_102 = { class: "flexAlign" }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d" }),
  /*#__PURE__*/_createTextVNode("客户收费金额")
], -1))
const _hoisted_104 = { class: "right" }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"10px"} }, null, -1))
const _hoisted_106 = { class: "flexAlign" }
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d" }),
  /*#__PURE__*/_createTextVNode("收款确认")
], -1))
const _hoisted_108 = { class: "right" }
const _hoisted_109 = /*#__PURE__*/_createTextVNode("点击签名")
const _hoisted_110 = { key: 1 }
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"10px"} }, null, -1))
const _hoisted_112 = { class: "flexAlign" }
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d" }),
  /*#__PURE__*/_createTextVNode("付款确认")
], -1))
const _hoisted_114 = { class: "right" }
const _hoisted_115 = /*#__PURE__*/_createTextVNode("点击签名")
const _hoisted_116 = { key: 1 }
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1))
const _hoisted_118 = { class: "flexCenter" }
const _hoisted_119 = /*#__PURE__*/_createTextVNode("提 交")

import { ref,onMounted } from 'vue';
	import { xmUser,requestAddTask,xmDetails2 } from '@/api/xmApi';
	import { apiName,requestMyuser,reqPostsaleanalysisEditinfo,reqPostsaleanalysisInfo,reqPostsaleanalysisFineList,reqPostsaleanalysisFineEdit,reqPostsaleanalysisFineDelete } from '@/api/api';
	import { ElMessage } from 'element-plus';
	import {requestConfigalllisttype3} from '@/api/configApi.js';
	import type { UploadUserFile } from 'element-plus'
	import { getCurrentInstance } from 'vue'
	
export default /*#__PURE__*/_defineComponent({
  name: 'EditPostsaleanalysislist',
  props: {
		editid:{
			type: Number,
			default: 0
		},
	},
  emits: ['cancelShowConfig'],
  setup(__props, { emit }) {

const props = __props

	const fileList = ref<UploadUserFile[]>([])
	
	const api = ref<string>(apiName)
	const wtlxlist = ref([])
	const ytgwlist = ref([])
	const zrbmrlist = ref([])
	const fineList = ref<any[]>([])
	
	const form = ref<any>({
		id:0,
		type:'',
		value:'',
	})
	
	//提交
	const submit = () => {
		if(form.value.fksj === ""){
			ElMessage.error("请输入反馈时间");
			return
		}
		// 验证罚款人信息是否完整
		for(let i = 0; i < fineList.value.length; i++){
			const item = fineList.value[i];
			if(!item.fkrxm || !item.fkje || !item.fksj){
				ElMessage.warning(`第${i+1}条罚款人信息不完整，请补充姓名、金额和时间`);
				return;
			}
		}
		reqPostsaleanalysisEditinfo({
			id:props.editid,
			fksj:form.value.fksj,
			fkr:form.value.fkr,
			ddh:form.value.ddh,
			wtlx:form.value.wtlx,
			pfs:form.value.pfs,
			tzlx:form.value.tzlx,
			wtfl:form.value.wtfl,
			yysx:form.value.yysx,
			bcjjfa:form.value.bcjjfa,
			ytfxdjfa:form.value.ytfxdjfa,
			gsjd:form.value.gsjd,
			ytgw:form.value.ytgw,
			zrbmr:form.value.zrbmr,
			nwb:form.value.nwb,
			ssjehj:form.value.ssjehj,
			clfy:form.value.clfy,
			rggz:form.value.rggz,
			clf:form.value.clf,
			kdf:form.value.kdf,
			bz:form.value.bz,
			fk:form.value.fk,
			khsfje:form.value.khsfje,
			skqrsj:form.value.skqrsj,
			skqrxm:form.value.skqrxm,
			fkqrsj:form.value.fkqrsj,
			fkqrxm:form.value.fkqrxm
		}).then((res:any)=>{
			if(res.status === 1){
				// 批量保存罚款人信息
				const pid = res.datalist || props.editid;
				if(fineList.value.length > 0){
					saveAllFines(pid);
				} else {
					ElMessage({message: res.msg, type: 'success', duration: 500});
					setTimeout(()=>{ emit("cancelShowConfig",1) },500)
				}
			} else {
				ElMessage({message: res.msg || '操作失败', type: 'error', duration: 500});
			}
		})
	}
	// 批量保存罚款人信息
	const saveAllFines = (pid: number) => {
		const promises = fineList.value.map((item: any) => {
			return reqPostsaleanalysisFineEdit({
				id: item.id,
				pid: pid,
				fkrxm: item.fkrxm,
				fkje: item.fkje,
				fksj: item.fksj
			});
		});
		Promise.all(promises).then(()=>{
			ElMessage({message: '提交成功', type: 'success', duration: 500});
			setTimeout(()=>{ emit("cancelShowConfig",1) },500)
		}).catch(()=>{
			ElMessage({message: '罚款信息保存异常', type: 'error', duration: 500});
			setTimeout(()=>{ emit("cancelShowConfig",1) },500)
		});
	}
	const cancel = () => {
		emit("cancelShowConfig")
	}
	onMounted(()=>{
		requestConfigalllisttype3({
            t1:'源头岗位'
        }).then((res:any)=>{
            if(res.status === 1){
                ytgwlist.value=res.datalist;
            }
        })
		requestConfigalllisttype3({
            t1:'责任部门/人'
        }).then((res:any)=>{
            if(res.status === 1){
                zrbmrlist.value=res.datalist;
            }
        })
		console.log(props.editid)
		GetDetails2();
	})
	const GetDetails2 = () => {
        reqPostsaleanalysisInfo({
            id:props.editid
        }).then((res:any)=>{
            if(res.status === 1){
                form.value=res.datalist;
				if(form.value.wtlx != ''){
					requestConfigalllisttype3({
						t1:form.value.wtlx
					}).then((res:any)=>{
						if(res.status === 1){
							wtlxlist.value=res.datalist;
						}
					})
				}
				// 加载罚款子表数据
				loadFineList();
            }
        })
    }
	// 加载罚款子表
	const loadFineList = () => {
		if(props.editid && props.editid > 0){
			reqPostsaleanalysisFineList({pid: props.editid}).then((res:any)=>{
				if(res.status === 1){
					fineList.value = res.datalist;
				}
			})
		}
	}
	// 添加罚款人
	const addFine = () => {
		fineList.value.push({
			id: 0,
			pid: props.editid,
			fkrxm: '',
			fkje: '',
			fksj: ''
		});
	}
	// 删除罚款人
	const deleteFine = (item: any, index: number) => {
		if(item.id && item.id > 0){
			reqPostsaleanalysisFineDelete({id: item.id}).then((res:any)=>{
				if(res.status === 1){
					fineList.value.splice(index, 1);
				}
			})
		} else {
			fineList.value.splice(index, 1);
		}
	}
	const changewtlx = () => {
		requestConfigalllisttype3({
            t1:form.value.wtlx
        }).then((res:any)=>{
            if(res.status === 1){
                wtlxlist.value=res.datalist;
				form.value.wtfl=''
            }
        })
	}
	
	// 收款确认签名
	const signSKQR = () => {
		const currentDate = new Date().toISOString().split('T')[0];
		form.value.skqrsj = currentDate;
		// 使用API获取当前用户信息
		requestMyuser().then((res:any)=>{
			if(res.status === 1){
				form.value.skqrxm = res.datalist[0].name;
				// 保存到localStorage以便后续使用
				localStorage.setItem('currentUserName', res.datalist[0].name);
			} else {
				ElMessage.warning('无法获取当前用户名，请联系管理员');
			}
		}).catch(() => {
			ElMessage.warning('获取用户信息失败，请联系管理员');
		});
	}
	
	// 付款确认签名
	const signFKQR = () => {
		const currentDate = new Date().toISOString().split('T')[0];
		form.value.fkqrsj = currentDate;
		requestMyuser().then((res:any)=>{
			if(res.status === 1){
				form.value.fkqrxm = res.datalist[0].name;
				localStorage.setItem('currentUserName', res.datalist[0].name);
			} else {
				ElMessage.warning('无法获取当前用户名，请联系管理员');
			}
		}).catch(() => {
			ElMessage.warning('获取用户信息失败，请联系管理员');
		});
	}

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_date_picker, {
          modelValue: form.value.fksj,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.fksj) = $event)),
          type: "date",
          placeholder: "反馈时间",
          "value-format": "YYYY-MM-DD"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_el_input, {
          modelValue: form.value.fkr,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.fkr) = $event)),
          placeholder: "请输入反馈人"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _hoisted_9,
    _createElementVNode("div", _hoisted_10, [
      _hoisted_11,
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_el_input, {
          modelValue: form.value.ddh,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.ddh) = $event)),
          placeholder: "请输入订单号"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _hoisted_13,
    _createElementVNode("div", _hoisted_14, [
      _hoisted_15,
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_component_el_select, {
          modelValue: form.value.wtlx,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.wtlx) = $event)),
          placeholder: "请选择",
          onChange: _cache[4] || (_cache[4] = ($event: any) => (changewtlx()))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_option, {
              label: "售后",
              value: "售后"
            }),
            _createVNode(_component_el_option, {
              label: "来料质检",
              value: "来料质检"
            }),
            _createVNode(_component_el_option, {
              label: "制成-零件质检",
              value: "制成-零件质检"
            }),
            _createVNode(_component_el_option, {
              label: "制成-半成品质检",
              value: "制成-半成品质检"
            }),
            _createVNode(_component_el_option, {
              label: "制成-面前质检",
              value: "制成-面前质检"
            }),
            _createVNode(_component_el_option, {
              label: "制成-成品质检",
              value: "制成-成品质检"
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    _hoisted_17,
    _createElementVNode("div", _hoisted_18, [
      _hoisted_19,
      _createElementVNode("div", _hoisted_20, [
        _createVNode(_component_el_input, {
          modelValue: form.value.pfs,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.pfs) = $event)),
          placeholder: "请输入平方数"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _hoisted_21,
    _createElementVNode("div", _hoisted_22, [
      _hoisted_23,
      _createElementVNode("div", _hoisted_24, [
        _createVNode(_component_el_select, {
          modelValue: form.value.tzlx,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value.tzlx) = $event)),
          placeholder: "请选择"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_option, {
              label: "白胚",
              value: "白胚"
            }),
            _createVNode(_component_el_option, {
              label: "混油",
              value: "混油"
            }),
            _createVNode(_component_el_option, {
              label: "木色",
              value: "木色"
            }),
            _createVNode(_component_el_option, {
              label: "五金",
              value: "五金"
            }),
            _createVNode(_component_el_option, {
              label: "其他",
              value: "其他"
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    _hoisted_25,
    _createElementVNode("div", _hoisted_26, [
      _hoisted_27,
      _createElementVNode("div", _hoisted_28, [
        _createVNode(_component_el_select, {
          modelValue: form.value.wtfl,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.value.wtfl) = $event)),
          placeholder: "请选择"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(wtlxlist.value, (item, index) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                label: item.value,
                value: `${item.value}`,
                key: index
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    _hoisted_29,
    _createElementVNode("div", _hoisted_30, [
      _hoisted_31,
      _createElementVNode("div", _hoisted_32, [
        _createVNode(_component_el_input, {
          modelValue: form.value.yysx,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.value.yysx) = $event)),
          type: "textarea",
          autosize: {minRows: 6},
          placeholder: "请输入原因事项"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _hoisted_33,
    _createElementVNode("div", _hoisted_34, [
      _hoisted_35,
      _createElementVNode("div", _hoisted_36, [
        _createVNode(_component_el_input, {
          modelValue: form.value.bcjjfa,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.value.bcjjfa) = $event)),
          placeholder: "请输入本次解决方案"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _hoisted_37,
    _createElementVNode("div", _hoisted_38, [
      _hoisted_39,
      _createElementVNode("div", _hoisted_40, [
        _createVNode(_component_el_input, {
          modelValue: form.value.ytfxdjfa,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((form.value.ytfxdjfa) = $event)),
          type: "textarea",
          autosize: {minRows: 6},
          placeholder: "请输入源头分析杜绝方案"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _hoisted_41,
    _createElementVNode("div", _hoisted_42, [
      _hoisted_43,
      _createElementVNode("div", _hoisted_44, [
        _createVNode(_component_el_input, {
          modelValue: form.value.gsjd,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((form.value.gsjd) = $event)),
          placeholder: "请输入改善进度"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _hoisted_45,
    _createElementVNode("div", _hoisted_46, [
      _hoisted_47,
      _createElementVNode("div", _hoisted_48, [
        _createVNode(_component_el_select, {
          modelValue: form.value.ytgw,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((form.value.ytgw) = $event)),
          placeholder: "请选择"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ytgwlist.value, (item, index) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                label: item.value,
                value: `${item.value}`,
                key: index
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    _hoisted_49,
    _createElementVNode("div", _hoisted_50, [
      _hoisted_51,
      _createElementVNode("div", _hoisted_52, [
        _createVNode(_component_el_select, {
          modelValue: form.value.zrbmr,
          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((form.value.zrbmr) = $event)),
          placeholder: "请选择"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(zrbmrlist.value, (item, index) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                label: item.value,
                value: `${item.value}`,
                key: index
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    _hoisted_53,
    _createElementVNode("div", _hoisted_54, [
      _hoisted_55,
      _createElementVNode("div", _hoisted_56, [
        _createVNode(_component_el_select, {
          modelValue: form.value.nwb,
          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((form.value.nwb) = $event)),
          placeholder: "请选择"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_option, {
              label: "内部",
              value: "内部"
            }),
            _createVNode(_component_el_option, {
              label: "外部",
              value: "外部"
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    _hoisted_57,
    _createElementVNode("div", _hoisted_58, [
      _hoisted_59,
      _createElementVNode("div", _hoisted_60, [
        _createVNode(_component_el_input, {
          modelValue: form.value.ssjehj,
          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((form.value.ssjehj) = $event)),
          placeholder: "请输入损失金额合计"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _hoisted_61,
    _createElementVNode("div", _hoisted_62, [
      _hoisted_63,
      _createElementVNode("div", _hoisted_64, [
        _createVNode(_component_el_input, {
          modelValue: form.value.clfy,
          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((form.value.clfy) = $event)),
          placeholder: "请输入差旅费用"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _hoisted_65,
    _createElementVNode("div", _hoisted_66, [
      _hoisted_67,
      _createElementVNode("div", _hoisted_68, [
        _createVNode(_component_el_input, {
          modelValue: form.value.rggz,
          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((form.value.rggz) = $event)),
          placeholder: "请输入人工工资"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _hoisted_69,
    _createElementVNode("div", _hoisted_70, [
      _hoisted_71,
      _createElementVNode("div", _hoisted_72, [
        _createVNode(_component_el_input, {
          modelValue: form.value.clf,
          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((form.value.clf) = $event)),
          placeholder: "请输入材料费"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _hoisted_73,
    _createElementVNode("div", _hoisted_74, [
      _hoisted_75,
      _createElementVNode("div", _hoisted_76, [
        _createVNode(_component_el_input, {
          modelValue: form.value.kdf,
          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((form.value.kdf) = $event)),
          placeholder: "请输入快递费"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _hoisted_77,
    _createElementVNode("div", _hoisted_78, [
      _hoisted_79,
      _createElementVNode("div", _hoisted_80, [
        _createVNode(_component_el_input, {
          modelValue: form.value.fk,
          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((form.value.fk) = $event)),
          placeholder: "请输入罚款"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _hoisted_81,
    _createElementVNode("div", _hoisted_82, [
      _createElementVNode("div", _hoisted_83, [
        _hoisted_84,
        _createVNode(_component_el_button, {
          type: "primary",
          size: "small",
          onClick: addFine
        }, {
          default: _withCtx(() => [
            _hoisted_85
          ]),
          _: 1
        })
      ]),
      (fineList.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fineList.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "fine-item"
              }, [
                _createElementVNode("div", _hoisted_87, [
                  _createElementVNode("div", _hoisted_88, [
                    _hoisted_89,
                    _createVNode(_component_el_input, {
                      modelValue: item.fkrxm,
                      "onUpdate:modelValue": ($event: any) => ((item.fkrxm) = $event),
                      placeholder: "请输入姓名",
                      size: "small"
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_90, [
                    _hoisted_91,
                    _createVNode(_component_el_input, {
                      modelValue: item.fkje,
                      "onUpdate:modelValue": ($event: any) => ((item.fkje) = $event),
                      placeholder: "请输入金额",
                      size: "small"
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_92, [
                    _hoisted_93,
                    _createVNode(_component_el_date_picker, {
                      modelValue: item.fksj,
                      "onUpdate:modelValue": ($event: any) => ((item.fksj) = $event),
                      type: "date",
                      placeholder: "选择日期",
                      "value-format": "YYYY-MM-DD",
                      size: "small"
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_94, [
                    _createVNode(_component_el_button, {
                      type: "danger",
                      size: "small",
                      onClick: ($event: any) => (deleteFine(item, index))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_95
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ])
                ])
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_96, "暂无罚款人信息"))
    ]),
    _hoisted_97,
    _createElementVNode("div", _hoisted_98, [
      _hoisted_99,
      _createElementVNode("div", _hoisted_100, [
        _createVNode(_component_el_input, {
          modelValue: form.value.bz,
          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((form.value.bz) = $event)),
          placeholder: "请输入备注"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _hoisted_101,
    _createElementVNode("div", _hoisted_102, [
      _hoisted_103,
      _createElementVNode("div", _hoisted_104, [
        _createVNode(_component_el_input, {
          modelValue: form.value.khsfje,
          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((form.value.khsfje) = $event)),
          placeholder: "请输入客户收费金额"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _hoisted_105,
    _createElementVNode("div", _hoisted_106, [
      _hoisted_107,
      _createElementVNode("div", _hoisted_108, [
        (!form.value.skqrxm)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              onClick: signSKQR,
              type: "primary",
              size: "small"
            }, {
              default: _withCtx(() => [
                _hoisted_109
              ]),
              _: 1
            }))
          : (_openBlock(), _createElementBlock("span", _hoisted_110, _toDisplayString(form.value.skqrsj) + " " + _toDisplayString(form.value.skqrxm), 1))
      ])
    ]),
    _hoisted_111,
    _createElementVNode("div", _hoisted_112, [
      _hoisted_113,
      _createElementVNode("div", _hoisted_114, [
        (!form.value.fkqrxm)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              onClick: signFKQR,
              type: "primary",
              size: "small"
            }, {
              default: _withCtx(() => [
                _hoisted_115
              ]),
              _: 1
            }))
          : (_openBlock(), _createElementBlock("span", _hoisted_116, _toDisplayString(form.value.fkqrsj) + " " + _toDisplayString(form.value.fkqrxm), 1))
      ])
    ]),
    _hoisted_117,
    _createElementVNode("div", _hoisted_118, [
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[23] || (_cache[23] = ($event: any) => (submit())),
        round: ""
      }, {
        default: _withCtx(() => [
          _hoisted_119
        ]),
        _: 1
      })
    ])
  ]))
}
}

})